import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getRedeemCodelist, getChannelOptionList } from '@/api/exchange';
let ExchangeManage = class ExchangeManage extends Vue {
    constructor() {
        super(...arguments);
        this.channelOptions = [];
        this.couponFilter = {
            searchType: 1,
            keyword: '',
            activityType: -1,
            channelId: '-1',
            redeemCodeStatus: -1,
        };
        this.couponList = [];
        this.isCouponLoading = false;
        this.couponPaginator = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
    }
    created() {
        if (this.activityId && this.activityId != '') {
            this.couponFilter.searchType = 2;
            this.couponFilter.keyword = this.activityId;
        }
        this.getChannelOption();
        this.getList();
    }
    getChannelOption() {
        getChannelOptionList().then((res) => {
            if (res.data.status === 200) {
                this.channelOptions = res.data.data;
            }
            else {
                this.channelOptions = [];
            }
        });
    }
    getList() {
        let data = {
            keyword: this.couponFilter.keyword,
            searchType: this.couponFilter.searchType,
            channelId: this.couponFilter.channelId,
            redeemCodeStatus: this.couponFilter.redeemCodeStatus,
            pageNo: this.couponPaginator.pageNo,
        };
        getRedeemCodelist(data).then((res) => {
            if (res.data.status === 200) {
                this.couponList = res.data.data.list || [];
                this.couponPaginator.pageSize = Number(res.data.data.pageSize);
                this.couponPaginator.total = Number(res.data.data.total);
                this.couponPaginator.pageNo = Number(res.data.data.pageNum);
            }
            else {
                this.couponList = [];
                this.couponPaginator.total = 0;
                this.couponPaginator.pageNo = 1;
            }
        });
    }
    handleCouponFilter() {
        this.couponPaginator.pageNo = 1;
        this.getList();
    }
    handleCouponPageChange(pageNo) {
        this.couponPaginator.pageNo = pageNo;
        this.getList();
    }
};
tslib_1.__decorate([
    Prop({ default: '' })
], ExchangeManage.prototype, "activityId", void 0);
ExchangeManage = tslib_1.__decorate([
    Component({
        filters: {
            format(time) {
                if (!time) {
                    return '-';
                }
                let date = new Date(time);
                let fmt = 'yyyy-MM-dd hh:mm:ss';
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                var o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (var k in o) {
                    if (new RegExp(`(${k})`).test(fmt)) {
                        var str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            }
        },
    })
], ExchangeManage);
export default ExchangeManage;
